import { useEffect, useState } from "react";
import { AngleUpIcon } from "assets/svgs";
import { useAppSelector } from "store/hooks";
import { userSettingState } from "store/selectors";
import styles from "./styles.module.css";

export function CollapsiblePanel({
  header,
  children,
  defaultCollapsibleState = false,
  minHeight,
  containerHeight,
  id,
}: any) {
  const [isOpen, setIsOpen] = useState(defaultCollapsibleState);
  const { isDarkMode } = useAppSelector(userSettingState);

  useEffect(() => {
    defaultCollapsibleState && setIsOpen(defaultCollapsibleState);
  }, [defaultCollapsibleState]);

  const togglePanel = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div
      className={`${styles["collapsible-container"]} ${
        isDarkMode ? styles.darkModeContainer : ""
      }`}
      style={
        containerHeight && isOpen
          ? {
              minHeight: containerHeight,
            }
          : {}
      }
      id={id}
    >
      <div className={styles["collapsible-header"]}>
        {header}

        <AngleUpIcon
          className={isOpen ? styles["rotate-arrow"] : "shrink-0"}
          onClick={togglePanel}
        />
      </div>
      <div
        className={`${styles["collapsible-content"]} ${
          isOpen ? styles["open"] : ""
        }`}
        style={
          minHeight && isOpen
            ? {
                minHeight: minHeight,
              }
            : {}
        }
      >
        {children}
      </div>
    </div>
  );
}
